<template>
  <section class="navigation">
    <mobility-nav-promo-banner />

    <!--<nav-top class="nav-top" /> -->
    <nav-center-mobility />
    <nav-steps
      class="nav-hero--steps"
      :is-visible="isSteppingVisible()"
    />
    <section class="booking">
      <nav-booking-mobility
        v-if="showHeader"
        class="-sticky"
      />
    </section>
    <nav-wrap />
  </section>
</template>

<script>
// import NavTop from './NavTop';
import { mapState } from 'vuex'
import NavCenterMobility from './NavCenterMobility';
import NavBookingMobility from './NavBookingMobility'
import NavSteps from './NavSteps'
import NavWrap from './NavWrap';
import MobilityNavPromoBanner from './MobilityNavPromoBanner'

export default {
  name: 'RentNavigation',
  components: {
    // NavTop,
    NavCenterMobility,
    NavWrap,
    NavBookingMobility,
    MobilityNavPromoBanner,
    NavSteps,

  },
  computed: {
    ...mapState({
      stepping: (state) => state.stepping,
    }),
    showHeader() {
      return this.$store.state.stepping.header
    },
  },
  methods: {
    isSteppingVisible() {
      return !!this.stepping.currentStep
    },
  },

};
</script>

<style scoped lang="scss">
@import "../../../../../_src/sass/config/vars";
@import "../../../../../_src/sass/config/mixins";
@import "../../../../../_src/sass/config/responsive";

.navigation {
  @include transition(0.3s ease all);

  background-color: $gray;
  box-sizing: border-box;
  display: flex;
  flex: 1;
  flex-direction: column;
  //height: 9rem;
  left: 0;
  max-width: 100vw;
  padding: 10px 0;
  padding-bottom: 14px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;

  &::before {
    @include teq-breakpoint($medium) {
      background: #ddd;
      content: '';
      height: 1.2px;
      left: 0;
      position: absolute;
      top: 9rem;
      width: 100%;
    }
  }

  @include teq-breakpoint($medium) {
    border-bottom: none;
    height: auto;
    padding: 0;
    padding-bottom: 0;
    position: fixed;

    &::before {
      background: none;
    }
  }

  .nav-open & {
    @include openMobileNav;
  }
}

.navigation > div {
  display: flex;
  flex: 1;
  flex-direction: column;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
}

.nav-top {
  display: none;

  @include teq-breakpoint($medium) {
    display: flex;
  }
}

.booking {
  @include teq-breakpoint($medium) {
    display: none;
  }
}
</style>
